import Table, { EditedRow } from "./Table";
import TableColumn from "./TableColumn";

export default class Inserter {
    protected table: Table;
    protected editedRow: EditedRow;

    constructor(table: Table) {
        this.table = table;
        this.editedRow = table.editRow(null);
    }

    public set = (columnName: string, value: any) => {
        let column : TableColumn | null = this.table.findColumn(columnName);
        if (!column) {
            throw new Error(`No column '${columnName}' in table '${this.table.name}'`);
        }
        this.editedRow[1].set(column, value);
    }
}